import $ from "jquery";

const Highcharts = () => {
    const init = () => {
        initCharts();
    };

    const initCharts = () => {
        const el = {
            Highcharts: ".HighchartsCard",
            HighchartsCardInfo: ".HighchartsCard__Info",
            HighchartsCardTooltip: ".HighchartsCard__Tooltip",
        };

        $(document).on("mouseover", el.HighchartsCardInfo, function () {
            const idArr = $(this).attr("id").split("__");
            const id = idArr[idArr.length - 1];
            const isSlider = $(this).attr("id").includes("Slider");
            const tooltipElement = isSlider ? ` #HighchartsCard__Tooltip__Slider__${id}` : `#HighchartsCard__Tooltip__${id}`;

            $(tooltipElement).css({
                display: "block",
                opacity: "1",
                transform: "translateY(0)",
            });
        });

        $(document).on("mouseleave", el.HighchartsCardTooltip, function () {
            const idArr = $(this).attr("id").split("__");
            const id = idArr[idArr.length - 1];
            const tooltipElement = `#HighchartsCard__Tooltip__${id}, #HighchartsCard__Tooltip__Slider__${id}`;
            $(tooltipElement).css({
                opacity: "0",
                transform: "translateY(20px)",
            });
            setTimeout(() => {
                $(tooltipElement).css("display", "none");
            }, 300);
        });
    };

    init();
};

try {
    Highcharts();
} catch (e) {
    console.error("Post initChart: ", e);
}
